import { GridAction } from '@eforall/dashboard';
import { SurveysByTopicRow } from '../surveys-by-topic-view.part';

export function getActions() {

	const actions: GridAction<SurveysByTopicRow>[] = [];

	return actions;
}